import { InjectionToken } from '@angular/core';
import { DataObject } from '@shared/models/data-object.model';
import { Observable } from 'rxjs';

export interface FilterOptionService {
  get searchParams(): DataObject;
  clearNullFilter$: Observable<void>;
  searchQuery(filters): void;

  clearNullFilters(): void;
}

export const FILTER_OPTION_SERVICE_TOKEN = new InjectionToken<FilterOptionService>('FILTER_OPTION_SERVICE');
